/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientInterestRegistrationRepresentative
 */
export interface ClientInterestRegistrationRepresentative {
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    readonly user?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    readonly url?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientInterestRegistrationRepresentative
     */
    readonly dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientInterestRegistrationRepresentative
     */
    readonly dateUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    role?: ClientInterestRegistrationRepresentativeRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientInterestRegistrationRepresentative
     */
    phoneNumber?: string | null;
}


/**
 * @export
 */
export const ClientInterestRegistrationRepresentativeRoleEnum = {
    Manager: 'Manager',
    Accountant: 'Accountant',
    Lawyer: 'Lawyer',
    Representative: 'Representative',
    Company: 'Company'
} as const;
export type ClientInterestRegistrationRepresentativeRoleEnum = typeof ClientInterestRegistrationRepresentativeRoleEnum[keyof typeof ClientInterestRegistrationRepresentativeRoleEnum];


/**
 * Check if a given object implements the ClientInterestRegistrationRepresentative interface.
 */
export function instanceOfClientInterestRegistrationRepresentative(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ClientInterestRegistrationRepresentativeFromJSON(json: any): ClientInterestRegistrationRepresentative {
    return ClientInterestRegistrationRepresentativeFromJSONTyped(json, false);
}

export function ClientInterestRegistrationRepresentativeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientInterestRegistrationRepresentative {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'dateCreated': !exists(json, 'date_created') ? undefined : (new Date(json['date_created'])),
        'dateUpdated': !exists(json, 'date_updated') ? undefined : (new Date(json['date_updated'])),
        'name': json['name'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phone_number') ? undefined : json['phone_number'],
    };
}

export function ClientInterestRegistrationRepresentativeToJSON(value?: ClientInterestRegistrationRepresentative | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'role': value.role,
        'email': value.email,
        'phone_number': value.phoneNumber,
    };
}

